import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    GetShowQuery,
    GetShowQueryVariables,
    PerformerOrder,
    SearchPerformersQuery,
    SearchPerformersQueryVariables,
    VirtualSpacesQuery,
    VirtualSpacesQueryVariables,
} from 'generated/graphql'

export const queryShows = gql`
    query shows($first: Int, $after: ID, $eventId: EventID!, $search: String, $sort: ShowOrder, $upcomingOnly: Boolean) {
        event (id: $eventId) {
            shows(first: $first, after: $after, search: $search, orderBy: $sort, upcomingOnly: $upcomingOnly) {
                totalCount,
                edges {
                    cursor
                    node {
                        id
                        isContainer
                        name
                        description
                        startDate
                        endDate
                        virtualSpace
                        mapitem
                        virtualImage
                        color
                        sponsor {
                            id
                            name
                            logo
                        }
                        items {
                            id
                            name
                            startDate
                            endDate
                            virtualSpace
                            mapitem
                            virtualImage
                            color
                            sponsor {
                                id
                                name
                                logo
                            }
                        }
                    }
                }
                pageInfo {
                    hasPreviousPage
                    hasNextPage
                    startCursor
                    endCursor
                }
                totalCount
            }
        }
    }
`

const queryShowDetails = gql`
    query getShow($id: Int!) {
        show(id: $id) {
            id
            externalId
            name
            startDate
            endDate
            color
            description
            attachment
            attachmentName
            performers {
                edges {
                    node {
                        id, mugshot, name,
                    }
                }
            }
            virtualSpace {
                id
            }
            mapitem {
                id
            }
            moderator {
                hasLoggedOn
                firstName
                email
            }
            streamUrl
            embeddedUrl
            enableChat
            showAttendees
            streamIsContinues
            virtualImage
            image
            sponsor {
                id
                name
                logo
            }
            container {
                id
            }
            tags {
                id
            }
            onlyForSegments {
                id
            }
            playbackUrl
            releaseDate
        }
    }
`
export const getShow = async (id: number) => {
    const query = graphql.createQuery<GetShowQuery, GetShowQueryVariables>(queryShowDetails)
    const response = await query({ id })
    return response.data.show
}

// Performers
const queryPerformers = gql`
    query performers($eventId: EventID!, $first: Int!, $filters: PerformerFilter, $sort: PerformerOrder) {
        event (id: $eventId) {        
            performers(first: $first, filters: $filters, orderBy: $sort) {
                edges {
                    node {
                        id
                        name
                        mugshot
                    }
                }
            }
        }
    }
`
export const getPerformers = (eventId, search) => (
    graphql.createQuery<
        SearchPerformersQuery, SearchPerformersQueryVariables
    >(queryPerformers)({
        eventId, filters: { name: { iContains: search } }, first: 49, sort: PerformerOrder.TitleAsc
    })
)

// Spaces
const querySpaces = gql`
    query virtualSpaces($eventId: EventID!, $first: Int) {
        event(id: $eventId) {
            spaces(first: $first) {
                edges {
                    node {
                        id
                        name
                        enableChat
                        presentationFields {
                            streamIsContinues
                            streamUrl
                            interactionIsContinues
                            interactionUrl
                            showAttendees
                        }
                    }
                }
            }
        }
    }
`
export const getSpaces = graphql.createQuery<VirtualSpacesQuery, VirtualSpacesQueryVariables>(querySpaces)

export const showContainersQuery = gql`
    query showContainers($eventSlug: String!) {
        showContainers(eventSlug: $eventSlug) {
            id
            externalId
            startDate
            endDate
            name
            subtitle
            description
            color
            image
        }
    }
`

export const programTagsQuery = gql`
    query programTags($eventId: EventID!) {
        event(id: $eventId) {
            programTags {
                id
                text
                color
                order
                category {
                    id
                    text
                    order
                }
            }
        }
    }
`

export const programTagCategoriesQuery = gql`
    query programTagCategories($eventId: EventID!) {
        event(id: $eventId) {
            programTagCategories {
                id
                order
                text
            }
        }
    }
`

// Show container (Parent folder)
export const showContainerQuery = gql`
    query showContainer($id: Int!) {
        showContainer(id: $id) {
            id
            externalId
            startDate
            endDate
            name
            subtitle
            description
            color
            image
            playbackUrl
            releaseDate
            virtualSpace {
                id
            }
            mapitem {
                id
            }
            tags {
                id
            }
            sponsor {
                id
            }
        }
    }
`
